import styled from 'styled-components/macro'

export const DividerDashed = styled.div`
  height: 1px;
  width: 100%;
  border-top: 1px dashed ${({ theme }) => theme.secondary3};
`
